var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75992 22.5H17.2399C19.9999 22.5 21.6199 20.9386 21.7499 18.8786V9.99C21.8899 7.83 20.1699 7 17.9999 7C17.3899 7 16.8299 6.65 16.5499 6.11L15.8299 4.66C15.3699 3.75 14.1699 3 13.1499 3H10.8599C9.82992 3 8.62992 3.75 8.16992 4.66L7.44992 6.11C7.16992 6.65 6.60992 7 5.99992 7C3.82992 7 2.10992 7.83 2.24992 9.99L2.24978 18.8786C2.36978 20.9386 3.99992 22.5 6.75992 22.5Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.5H13.5",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5C13.79 18.5 15.25 17.04 15.25 15.25C15.25 13.46 13.79 12 12 12C10.21 12 8.75 13.46 8.75 15.25C8.75 17.04 10.21 18.5 12 18.5Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCamera);
export default __webpack_public_path__ + "static/media/file-camera.7cb91af1d376214afe54d854eb920b8e.svg";
export { ForwardRef as ReactComponent };